import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private localStorage: LocalStorageService, private sessionStorage: SessionStorageService) {
    }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request || !request.url || (/^http/.test(request.url) && !(environment.cmsBase && request.url.startsWith(environment.cmsBase)))) {
      return next.handle(request);
    }

        // Exclude bearer token for specific external URLs
        if (!this.shouldIncludeToken(request.url)) {
            return next.handle(request); // Proceed without modifying the request
        }

        const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
        if (!!token) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token
                }
            });
        }
        return next.handle(request);
    }

    private shouldIncludeToken(url: string): boolean {
        // Add your external API URLs here or the logic to detect them
        const excludedUrls = [environment.indicatorFrameworkApiBase];
        return !excludedUrls.some(excludedUrl => url.startsWith(excludedUrl));
    }
}
